/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientDepartmentRequest = {
    It: 'IT',
    Marketing: 'MARKETING',
    GeneralAdministration: 'GENERAL_ADMINISTRATION',
    Purchasing: 'PURCHASING',
    Accounting: 'ACCOUNTING',
    HumanResources: 'HUMAN_RESOURCES',
    Operations: 'OPERATIONS',
    Sales: 'SALES',
    Management: 'MANAGEMENT',
    Product: 'PRODUCT',
    Communication: 'COMMUNICATION'
} as const;
export type ClientDepartmentRequest = typeof ClientDepartmentRequest[keyof typeof ClientDepartmentRequest];


export function instanceOfClientDepartmentRequest(value: any): boolean {
    for (const key in ClientDepartmentRequest) {
        if (Object.prototype.hasOwnProperty.call(ClientDepartmentRequest, key)) {
            // @ts-ignore
            if (ClientDepartmentRequest[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientDepartmentRequestFromJSON(json: any): ClientDepartmentRequest {
    return ClientDepartmentRequestFromJSONTyped(json, false);
}

export function ClientDepartmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDepartmentRequest {
    return json as ClientDepartmentRequest;
}

export function ClientDepartmentRequestToJSON(value?: ClientDepartmentRequest | null): any {
    return value as any;
}

